module.exports = __webpack_public_path__ + "img/_qft-up_.f25fe398.svg";